(function (algolia) {
  'use strict';

  algolia.translations = {
    search: "Aktuelle Suche",
    noCollectionFound: "Keine passenden Kollektionen",
    allProducts: "Alle Produkte anzeigen",
    matching: "",
    sortBy: "Sortieren nach",
    relevance: "Relevanz",
    outOf: "Nicht Verfügbar",
    resultsFound: "Suchergebnissen",
    oneResultFound: "Ein Ergebnis gefunden",
    noResultFound: "Keine Ergebnisse gefunden",
    addToCart: "In den Warenkorb legen",
    searchForProduct: "Suche nach Produkte",
    selectedFilter: "Ausgewählte Filter",
    clearAll: "Alles löschen",
    noPageFound: "Keine passenden Seiten",
    outOfStock: "Nicht verfügbar",
  };

  algolia.translation_helpers = {
    no_result_for: function (text, render) {
      return 'Keine Ergebnisse für die Suche nach ' + render(text) + '';
    },
    in: function (text, render) {
      return 'in ' + render(text) + 's';
    },

    try_clear_or_change_input: function (text, render) {
      var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, 'g');
      var html_tags = text.match(regex);
      return 'Versuchen Sie ' + render(html_tags[0]) + ' clearing filters ' + render(html_tags[1]) + ' or ' + render(html_tags[2]) + ' changing your input ' + render(html_tags[3]) + '';
    },
    outOf: function (text, render) {
      return '' + render(text) + ' aus';
    },

    by: function (text, render) {
      return 'Nach ' + render(text) + '';
    }
  };

}(algoliaShopify));
